import { MouseEventHandler, memo, useCallback, useState } from 'react'

import { ColorPickerItem } from '@components/ColorPickerPopover/index.styles'
import { CustomTag } from '@modules/custom-tags/types'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'

import { TagColorPickerWrapper } from '../index.styles'
import TagColorPickerPopover from './TagColorPickerPopover'

export interface TagColorPickerProps {
  tag: CustomTag
  existingTags: CustomTag[]
  onColorSelected: (newColor: string) => void
}

const TagColorPicker = ({ tag, existingTags, onColorSelected }: TagColorPickerProps) => {
  const [colorPopupRef, setColorPopupRef] = useState<HTMLElement | null>()
  const handleColorSelect = useCallback(
    (newColor: string | undefined) => {
      if (newColor && tag.color !== newColor) {
        onColorSelected(newColor)
      }

      setColorPopupRef(null)
    },
    [tag.color, onColorSelected],
  )

  const handleColorPickerClick: MouseEventHandler<HTMLDivElement> = useCallback(
    e => {
      setColorPopupRef(colorPopupRef ? null : (e?.target as HTMLElement))
    },
    [colorPopupRef],
  )

  const defaultArrowStyling = {
    margin: '-4px 0 -4px -4px',
    fontSize: '16px',
    color: '#353535',
  }

  return (
    <TagColorPickerWrapper onClick={handleColorPickerClick}>
      <ColorPickerItem $color={tag.color} $size="13px" />
      <KeyboardArrowDownIcon
        sx={{ ...((colorPopupRef && { transform: 'rotate(180deg)', ...defaultArrowStyling }) || defaultArrowStyling) }}
      />
      {colorPopupRef && (
        <TagColorPickerPopover anchorEl={colorPopupRef} existingTags={existingTags} tag={tag} onColorPicked={handleColorSelect} />
      )}
    </TagColorPickerWrapper>
  )
}

export default memo(TagColorPicker)
